import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/powercabs-logo-black.svg';
import UpdatePasswordModal from '../components/UpdatePasswordModal';

const Profile = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [userData, setUserData] = useState({
    name: 'User',
    email: '',
  });
  const [password, setPassword] = useState('');

  useEffect(() => {
    const storedName = localStorage.getItem('name') || 'User';
    const storedEmail = localStorage.getItem('email') || '';
    setUserData({ name: storedName, email: storedEmail });
  }, []);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handlePasswordSubmit = async (e) => {
    if (!password) {
      console.error('Password cannot be empty');
      return;
    }

    try {
      const key = localStorage.getItem('key') || '';
      const cid = localStorage.getItem('authToken') || '';

      const data = new URLSearchParams({
        type: 'updatepass',
        key: key,
        cid: cid,
        pass: password,
      });

      const response = await fetch(
        'https://app.mindstreamsoft.com/crp_employee.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: data,
        }
      );

      const result = await response.json();

      if (result.message && result.message.toLowerCase().includes('success')) {
        setPassword('');
        return true;
      } else {
        console.error(
          'Password update failed:',
          result.message || 'Unknown error'
        );
        return false;
      }
    } catch (error) {
      console.error('Password update error:', error.message);
      return false;
    }
  };

  const handleUpdateClick = async () => {
    const success = await handlePasswordSubmit();
    if (success) {
      openModal();
    }
  };

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <div className='dashboard-container'>
      <div className='content'>
        <div className='card'>
          <div className='d-flex justify-content-between align-items-center flex-wrap p-3 p-sm-5'>
            <div className='d-flex flex-column flex-md-row align-items-md-center'>
              <img
                src={logo}
                alt='Company Logo'
                className='me-3'
                style={{ borderRadius: '8px' }}
              />
              <div>
                <h5 className='mb-1'>{userData.name}</h5>
                <p className='text-muted mb-0'>{userData.email}</p>
              </div>
            </div>

            <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center'>
              <Link
                to='#'
                className='btn mt-md-3'
                style={{
                  backgroundColor: '#f37a20',
                  color: '#fff',
                  textDecoration: 'none',
                  borderRadius: '10px',
                  width: '85px',
                }}
              >
                Edit
              </Link>
            </div>

            <div className='row g-3 mb-4'>
              <h6
                className='mb-3 mt-5'
                style={{ fontSize: '20px', fontWeight: '600' }}
              >
                Corporate Details
              </h6>
              <div className='col-md-6'>
                <label
                  className='mb-1'
                  style={{ minWidth: '130px', color: '#1f1f21' }}
                >
                  Name
                </label>
                <input
                  type='text'
                  className='form-control custom-input'
                  placeholder={userData.name}
                  readOnly
                />
              </div>
              <div className='col-md-6'>
                <label
                  className='mb-1'
                  style={{ minWidth: '130px', color: '#1f1f21' }}
                >
                  Email
                </label>
                <input
                  type='email'
                  className='form-control custom-input'
                  placeholder={userData.email}
                  readOnly
                />
              </div>
              <div className='col-md-6'>
                <label
                  className='mb-1'
                  style={{ minWidth: '130px', color: '#1f1f21' }}
                >
                  Contact
                </label>
                <input
                  type='text'
                  className='form-control custom-input'
                  placeholder='Your contact'
                  readOnly
                />
              </div>
              <div className='col-md-6'>
                <label
                  className='mb-1'
                  style={{ minWidth: '130px', color: '#1f1f21' }}
                >
                  Address
                </label>
                <input
                  type='text'
                  className='form-control custom-input'
                  placeholder='Your address'
                  readOnly
                />
              </div>
              <div className='row g-3 mb-4'>
                <h6 style={{ fontSize: '20px', fontWeight: '600' }}>
                  Password
                </h6>
                <div className='col-md-6'>
                  <label
                    className='mb-1'
                    style={{ minWidth: '130px', color: '#1f1f21' }}
                  >
                    Update Password
                  </label>
                  <input
                    type='password'
                    className='form-control custom-input'
                    placeholder='*****************'
                    value={password}
                    onChange={handlePasswordChange}
                  />
                </div>
                <div className='col-md-2 mt-5'>
                  <button
                    onClick={handleUpdateClick}
                    className='btn text-white'
                    style={{ backgroundColor: '#ff7a00', borderRadius: '8px' }}
                  >
                    Update
                  </button>
                  <UpdatePasswordModal
                    isOpen={isModalOpen}
                    onClose={closeModal}
                  />
                </div>
              </div>

              <div className='row g-3 mb-2'>
                <h6 style={{ fontSize: '20px', fontWeight: '600' }}>
                  Account Preferences
                </h6>
                <div className='col-md-6'>
                  <label
                    className='mb-1'
                    style={{ minWidth: '130px', color: '#1f1f21' }}
                  >
                    Notifications
                  </label>
                  <div className='form-check mb-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      id='rideNotifications'
                      defaultChecked
                    />
                    <label
                      className='form-check-label'
                      htmlFor='rideNotifications'
                    >
                      Ride Notifications
                    </label>
                  </div>
                  <div className='form-check mb-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      id='emailNotifications'
                      defaultChecked
                    />
                    <label
                      className='form-check-label'
                      htmlFor='emailNotifications'
                    >
                      Email Notifications
                    </label>
                  </div>
                  <div className='form-check mb-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      id='promotions'
                    />
                    <label className='form-check-label' htmlFor='promotions'>
                      Promotions
                    </label>
                  </div>
                  <div className='form-check'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      id='alerts'
                    />
                    <label className='form-check-label' htmlFor='alerts'>
                      Alerts
                    </label>
                  </div>

                  <div className='mt-4'>
                    <button
                      className='btn text-white'
                      style={{
                        backgroundColor: '#ff7a00',
                        borderRadius: '8px',
                        width: '150px',
                      }}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
